export class SignatureModel {
    Id: number;
    UserId: number;
    DocumentId: number;
    SignatureData: string;
    SignatureDataBinary: any; // Using `any` for binary data; can be adjusted as needed
    CreatedAt: string | null;
    UpdatedAt: string | null;

    constructor(
        Id: number,
        UserId: number,
        DocumentId: number,
        SignatureData: string,
        SignatureDataBinary: any,
        CreatedAt: string | null,
        UpdatedAt: string | null
    ) {
        this.Id = Id;
        this.UserId = UserId;
        this.DocumentId = DocumentId;
        this.SignatureData = SignatureData;
        this.SignatureDataBinary = SignatureDataBinary;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
    }
}
